import { render, staticRenderFns } from "./logincode.vue?vue&type=template&id=52212c0a"
import script from "./logincode.vue?vue&type=script&lang=js"
export * from "./logincode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports